import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";
import React from "react";

export const UploadDataIcon = ({
  width = "24",
  height = "24",
  color = "#1C3C6C",
  opacity = "1",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} opacity={opacity}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5423 15.334V7.52357L8.05065 10.0152L6.70898 8.62565L11.5007 3.83398L16.2923 8.62565L14.9507 10.0152L12.459 7.52357V15.334H10.5423ZM5.75065 19.1673C5.22357 19.1673 4.77251 18.9798 4.39748 18.6048C4.02246 18.2297 3.83462 17.7784 3.83398 17.2507V14.3757H5.75065V17.2507H17.2507V14.3757H19.1673V17.2507C19.1673 17.7777 18.9798 18.2291 18.6048 18.6048C18.2297 18.9804 17.7784 19.168 17.2507 19.1673H5.75065Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
